<template>
  <div class="box">
    <div class="box-slider" ref="slider">
      <div class="process" ref="process" :style="{ width: `${width}%` }">
        <div class="trunk" ref="trunk"></div>
      </div>
    </div>
  </div>
  <!-- </div> -->
</template>
<script>
const EVENT_NAME = {
  ON_PLAY: 'on-play',
  ON_PAUSE: 'on-pause',
  ON_CHANGE: 'on-change',
  ON_CLOSE: 'on-close',
};

/*
 * startTime 进度条最小值
 * endTime 进度条最大值
 * currentTime 对当前值进行双向绑定实时显示拖拽进度
 * */
export default {
  props: {
    startTime: {
      type: [String, Date],
      required: true,
    },
    endTime: {
      type: [String, Date],
      required: true,
    },
    isPlay: {
      type: Boolean,
      required: true,
    },
    goOn: {
      type: Boolean,
      required: true,
    },
    init_width: {
      type: Boolean,
      // required: true
    },
    playSpeed: {
      type: Number,
      //  required: true
    },
  },
  components: {},
  data() {
    return {
      start: moment(new Date(this.startTime)).format('HH:ss'),
      end: moment(new Date(this.endTime)).format('HH:ss'),
      unit: '',
      step: 0,
      //    times: [],
      clock: null,
      current: 0,
      process: null,
      thunk: null,
      currentS: 0, //当前秒数
      currentTime: 0, //传给父级的当前时间
      width: 0,
      curPlaySpeed: 3,
    };
  },
  computed: {
    times() {
      let startS = moment(this.startTime).valueOf() / 1000;
      let endS = moment(this.endTime).valueOf() / 1000;
      console.log(startS, endS);
      this.play();
      return [startS, endS];
    },
    //  width:{
    //  	get:function (){
    //  		return (this.currentS*100)/(this.times[1]-this.times[0]);
    //  	},
    //  	set:function (newValue){
    //  		console.log("--------------------",newValue)
    //  	},
    //  },
    left() {
      return this.slider
        ? `${
            this.slider.offsetWidth * (this.scale / 100) -
            this.thunk.offsetWidth / 2
          }px`
        : 0;
    },
    //  currentS(){
    //  	return
    //  }
  },
  watch: {
    init_width() {
      this.currentS = 0;
      this.width = 0;
    },
    goOn() {
      console.log('goOngoOngoOngoOn');
      this.currentS = this.currentTime / 1000 - this.times[0];
      console.log('this.currentS', this.currentS);
      this.play();
    },
    isPlay(val) {
      console.log('val', val);
      if (val) {
        this.play();
      } else {
        this.pause();
      }
    },
    overFlag(val) {
      if (this.time[val]) {
        this.$emit(EVENT_NAME.ON_CHANGE, this.time[val]);
      }
    },
    currentS() {
      this.width = (this.currentS * 100) / (this.times[1] - this.times[0]);
    },
    playSpeed(n) {
      this.curPlaySpeed = n;
    },
  },
  mounted() {
    this.curPlaySpeed = this.playSpeed;
    this.init();
  },
  beforeUnmount() {
    console.log('销毁');
    this.pause();
  },
  methods: {
    init() {
      this.addThunkEvent();
      this.play();
    },
    // 为滑块添加事件
    addThunkEvent() {
      this.slider = this.$refs.slider;
      this.process = this.$refs.process;
      this.thunk = this.$refs.trunk;
      const _this = this;

      this.thunk.onmousedown = function (e) {
        let thunkW = isNaN(parseInt(_this.width)) ? 0 : parseInt(_this.width);
        console.log('width', _this.width);
        console.log('thunkW', thunkW);
        let disX = e.clientX;
        console.log('disX', disX);
        document.onmousemove = function (e) {
          console.log(e.clientX - disX, _this.slider.offsetWidth);
          let newMove = ((e.clientX - disX) / _this.slider.offsetWidth) * 100;

          let width = thunkW + newMove;
          console.log('thunkW', thunkW);
          console.log('newMove', newMove);
          console.log('width', width);
          if (width <= 0) {
            _this.width = 0;
          } else if (width >= 100) {
            _this.width = 100;
          } else {
            _this.width = width;
          }
        };
        document.onmouseup = function (e) {
          _this.setCurrentTime();
          console.log('_this.width', _this.width);
          console.log('this.startTime', this.startTime);
          console.log('this.endTime', this.endTime);
          console.log('onmouseup', e.clientX);
          document.onmousemove = document.onmouseup = null;
        };
        return false;
      };
    },
    // 切换播放和暂停状态
    changePlayStatus() {},
    setCurrentTime() {
      this.pause();
      console.log(this.width);
      console.log(
        this.times,
        (this.times[1] - this.times[0]) * (this.width / 100)
      );
      this.currentTime =
        ((this.times[1] - this.times[0]) * (this.width / 100) + this.times[0]) *
        1000;
      console.log('this.,', this.currentTime);
      this.$emit(EVENT_NAME.ON_CHANGE, this.currentTime);
    },
    pause() {
      //    this.isplay = false;
      if (this.clock) {
        clearTimeout(this.clock);
        this.clock = null;
      }
    },
    play() {
      //    if (!this.isplay) {
      //      this.isplay = true;
      //    }
      this.pause();
      this.clock = setTimeout(() => {
        let currentSS = this.times[0] + this.currentS;
        console.log(currentSS, this.times[1]);
        if (currentSS < this.times[1]) {
          let delta = 1;
          if (this.playSpeed == 2) {
            delta = 0.5;
          } else if (this.playSpeed == 3) {
            delta = 1;
          } else if (this.playSpeed == 5) {
            delta = 4;
          } else if (this.playSpeed == 7) {
            delta = 8;
          } else if (this.playSpeed == 8) {
            delta = 12;
          }
          this.currentS += delta;
          console.log(this.currentS);
          this.play();
        } else {
          this.pause();
          this.$emit(EVENT_NAME.ON_PAUSE, 'stop');
          //        this.overFlag = 0;
          //        this.current = 0;
          //        this.isShowReport = true;
          //        this.pause();
        }
      }, 1000);
    },
    reset() {
      //    this.current = 0;
      //    this.isplay = false;
      //    this.isShowReport = false;
      //    if (this.clock) {
      //      clearTimeout(this.clock);
      //    }
    },
    close() {
      //    this.reset();
      //    this.$emit(EVENT_NAME.ON_CLOSE);
    },
  },
};
</script>
<style scoped lang="scss">
.box {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 4px;
  // background: #757B83;
  background: rgba(255, 255, 255, 0.2);
  .box-slider {
    width: 100%;
    height: 4px;
    .process {
      height: 100%;
      background: #ffffff;
      position: absolute;
      .trunk {
        @include bg-box(80px, 44px, 'trunk.png');
        cursor: pointer;
        position: absolute;
        right: 0;
        margin-right: -38px;
      }
    }
  }
}
/*.slider {
  position: relative;
  width: 88%;
  height: 100%;
}
.slider .mask {
  height: 100%;
  position: relative;
  overflow: hidden;
}
.slider .mask .process {
  position: absolute;
  left: 0;
  bottom: 0;
  width: 0;
  height: 100%;
  background: #00a7ff;
  z-index: 111;
}
.slider .thunk {
  position: absolute;
  top: -20%;
  left: 100px;
  width: 2%;
  z-index: 999;
}
.slider .mark {
  position: absolute;
  bottom: 0;
  width: 1px;
  background: white;
  z-index: 222;
}
.slider .time {
  position: absolute;
  bottom: -60%;
  font-size: 1vw;
  color: white;
  transform: translateX(-50%);
  z-index: 333;
}
.slider .markbg {
  position: relative;
  width: 100%;
  height: 100%;
  overflow: visible;
  background: $marksBackgroundColor;
  cursor: pointer;
}
.slider .block {
  transition: 0.2s all;
}
.slider .block > img {
  width: 100%;
}
.slider .block:hover {
  opacity: 0.6;
}*/
</style>
